import { environment } from '@quartz-iam-legacy/environments/environment';

(function () {
  'use strict';

  angular.module('homeControllers').controller('HomeController', Controller);

  Controller.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$modal',
    '$translate',
    'topBar',
    'employeeService',
    'authenticatedUser',
    'selfAccessRequestService',
  ];

  function Controller(
    $rootScope,
    $scope,
    $state,
    $modal,
    $translate,
    topBar,
    employeeService,
    authenticatedUser,
    selfAccessRequestService
  ) {
    var onTopSearchBlur = $scope.$on('top-search-blur', function (evt, searchInput) {
      $scope.search = '';
      $scope.showTitleAndSearchBox = true;
    });

    $scope.newIamUrl = environment.iamUrl;

    updatePageTitle();

    $scope.authenticatedUser = authenticatedUser;
    $scope.showTitleAndSearchBox = true;

    $scope.onSearch = onSearch;
    $scope.showPositionInHierarchyModal = showPositionInHierarchyModal;

    // Verify if can create an adhoc request
    selfAccessRequestService.getAdHocSelfAccessRequestStatus(authenticatedUser.IdentityName).then(function (status) {
      $scope.selfAccRequestEmpStatus = status;
    });

    // Create Ad-Hod Request
    $scope.createAdHocSelfAccessRequest = function () {
      if (_.isUndefined($scope.selfAccRequestEmpStatus)) return;
      if (!$scope.selfAccRequestEmpStatus.CanCreateAdHocRequest) return;
      if ($scope.selfAccRequestEmpStatus.isCreateingAdHoc) return;

      $scope.selfAccRequestEmpStatus.isCreateingAdHoc = true;

      selfAccessRequestService
        .createAdHocSelfAccessRequest($scope.selfAccRequestEmpStatus.EmployeeID)
        .then(function (req) {
          $state.go(req.SelfRequestPageRoute, {
            userAccessRequestId: req.UserAccessRequestID,
          });
        });
    };

    $scope.$on('$destroy', function () {
      // Deregister event handlers to prevent memory leaks
      onTopSearchBlur();
    });

    function onSearch() {
      if (!$scope.search) {
        return;
      }

      $rootScope.$broadcast('main-search-active', $scope.search);
      $scope.showTitleAndSearchBox = false;
    }

    function showPositionInHierarchyModal() {
      employeeService.getPositionInHierarchyPresident().then(function (presidentInHierarchy) {
        showModal(presidentInHierarchy);
      });

      function showModal(emp) {
        var modalScope = $scope.$new(true);
        modalScope.employee = emp;

        var positionInHierarchyModal = $modal({
          scope: modalScope,
          template: require('../employee/employeePositionInHierarchyModal.tpl.html'),
          placement: 'center',
          show: false,
        });
        positionInHierarchyModal.$promise.then(positionInHierarchyModal.show);
      }
    }

    /**
     * Update page title with current language translation
     */
    function updatePageTitle() {
      $translate('iam.home.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-home');
      });
    }
  }
})();
